const css = `
body {
    background: rgb(204,204,204); 
    }
    .table{
        /* display: grid; */
        width: 100%;
    }
    .tableColumn{
        width: 100%;
        display: grid;
        grid-template-columns: 2fr 4fr 2fr 7fr 3fr 4fr 2fr 4fr 2fr 5fr;
    }
    .tableHead{
        background-color: rgba(0, 0, 0, 0.3);
        border-bottom: 3px solid black;
    }
    .tableSum{
        font-weight: bold;
        font-size: small;
        font-style: italic;
    }
    .tableItem{
        word-wrap: break-word;
        text-align: center;
        align-self: center;
        justify-self: center;
    }
    .tableItemOuter{
        border: 1px solid black;
    }
`;
export default function Example() {

    const date = localStorage.getItem('date')
    const place = localStorage.getItem('place')
    const csv = JSON.parse(localStorage.getItem('csvData'));
    const billNo = localStorage.getItem('billno');
    
    var data = csv
    // for (var key in csv){
    //     const dt = csv[key]['date']
    //     const pl = csv[key]['place']
    //     if (dt===date && pl===place){
    //         data.push(csv[key]);
    //     }
    // }

    var sumBags = 0;
    var sumWeight = 0;
    var sumBagWt = 0;
    var sumNetWeight = 0;
    var sumAmount = 0;
    var index = 0;
    data.forEach((e)=>{
        console.log(e['veh']);
        sumBags += parseInt(e['bags']);
        sumWeight += parseFloat(e['weight']);
        sumBagWt += parseFloat(e['bagwt']);
        sumNetWeight += parseFloat(e['netweight']);
        sumAmount += parseFloat(e['amount']);
    })

    sumNetWeight = Math.round(sumNetWeight * 100) / 100
    sumWeight = Math.round(sumWeight * 100) / 100
    sumBagWt = Math.round(sumBagWt * 100) / 100
    sumAmount = Math.round(sumAmount * 100) / 100

  return (
    <div style={{ width: "210mm", height: "297mm", position: "relative" }}>
      <style>{css}</style>
      <img
        src="/assets/letterpad.jpg"
        alt=""
        style={{ width: "210mm", height: "297mm", position: "absolute" }}
      />
      <div
        className="billNo"
        style={{
          position: "absolute",
          top: "70mm",
          right: "170mm",
          fontWeight: "bold",
        }}
      >
        {billNo}
      </div>
      <div
        className="billNo"
        style={{
          position: "absolute",
          top: "70mm",
          right: "12mm",
          fontWeight: "bold",
        }}
      >
        {date}
      </div>
      <div
        className="headAddr"
        style={{
          position: "absolute",
          top: "70mm",
          right: "76mm",
          fontSize: "smaller",
        }}
      >
        Bihar Disttilers and Botllers Pvt Ltd.
      </div>
      <div
        className="headAddr"
        style={{
          position: "absolute",
          top: "74mm",
          right: "66mm",
          fontSize: "smaller",
        }}
      >
        ADD: Vill. Devri, Block-Garhani, Anumandal-Ara
      </div>
      <div
        className="headAddr"
        style={{
          position: "absolute",
          top: "78mm",
          right: "77mm",
          fontSize: "smaller",
        }}
      >
        Dist: Bhojpur, Bihar, Pin-802203,
      </div>
      <div
        className="headAddr"
        style={{
          position: "absolute",
          top: "82mm",
          right: "86mm",
          fontSize: "smaller",
        }}
      >
        GST: 10AAECB5830A1ZK
      </div>
      <div
        className="headAddr"
        style={{
          position: "absolute",
          top: "88mm",
          right: "77mm",
          fontSize: "x-large",
          fontWeight: "bold",
        }}
      >
        Loading from {place.toUpperCase()}
      </div>
      <div
        style={{
          position: "relative",
          top: "100mm",
          right: "-37px",
          width: "190mm",
          height: "190mm",
        }}
      >
        <div className="table">
          <div className="tableColumn tableHead">
            <div className="tableItemOuter">
              <div className="tableItem">Sr no.</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">Date</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">Bilty No.</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">Vehicle No.</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">Bags</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">Weight</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">Bag Wt.</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">Net Wt.</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">Rate</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">Amount</div>
            </div>
          </div>
          {

            data.map(item=>{
                index++;
                return(
                    <div className="tableColumn">
            <div className="tableItemOuter">
              <div className="tableItem">{index}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{item.date}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{item.bilty}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{item.veh}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{item.bags}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{Math.round(item.weight * 100) / 100}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{Math.round(item.bagwt * 100) / 100}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{Math.round(item.netweight * 100) / 100}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{Math.round(item.rate * 100) / 100}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{Math.round(item.amount * 100) / 100}</div>
            </div>
          </div>
                );
            })
          }
          <div className="tableColumn tableSum">
            <div className="tableItemOuter">
              <div className="tableItem">-</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">-</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">-</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">-</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{sumBags}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{sumWeight}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{sumBagWt}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{sumNetWeight}</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">-</div>
            </div>
            <div className="tableItemOuter">
              <div className="tableItem">{sumAmount}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
